module.exports = __webpack_public_path__ + "a6dec3ee26631e98263fc111d94a0f23.svg";